import {
  PRODUCTVARIAN_LOADING,
  GET_PRODUCTVARIAN,
  GET_PRODUCTVARIAN_SUCCESS,
  GET_PRODUCTVARIAN_FAIL,
  ADD_PRODUCTVARIAN_SUCCESS,
  ADD_PRODUCTVARIAN_FAIL,
  DELETE_PRODUCTVARIAN_SUCCESS,
  DELETE_PRODUCTVARIAN_FAIL,
  UPDATE_PRODUCTVARIAN_SUCCESS,
  UPDATE_PRODUCTVARIAN_FAIL,
  PRODUCTVARIAN_RESET
} from "./actionType";

const INIT_STATE = {
  productVarians: [],
  error: {},
};

const ProductVarian = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTVARIAN_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTVARIAN:
          return {
            ...state,
            productVarians: action.payload.data,
            isProductVarianCreated: false,
            isProductVarianSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTVARIAN_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTVARIAN_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductVarianCreated: false,
            isProductVarianSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTVARIAN: {
      return {
        ...state,
        isProductVarianCreated: false,
        loading: true,
      };
    }

    case PRODUCTVARIAN_LOADING: {
      return {
        ...state,
        isProductVarianCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTVARIAN_SUCCESS:
      return {
        ...state,
        isProductVarianCreated: true,
        loading: false,
        productVarians: [action.payload.data, ...state.productVarians],
      };

    case ADD_PRODUCTVARIAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTVARIAN_SUCCESS:
      return {
        ...state,
        loading: false,
        productVarians: state.productVarians.filter(
          productVarian => productVarian.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTVARIAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTVARIAN_SUCCESS:
      return {
        ...state,
        loading: false,
        productVarians: state.productVarians.map(productVarian =>
          productVarian.id.toString() === action.payload.data.id.toString() ? { ...productVarian, ...action.payload.data } : productVarian
        ),
      };

    case UPDATE_PRODUCTVARIAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTVARIAN_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductVarian;